module.exports = __webpack_public_path__ + "img/ice.404193ce.svg";